import * as d3 from "d3";

function thresholdFormat(thresholdsValues, i, sin_info, roundedValues) {
  if (thresholdsValues[thresholdsValues.length - 1] > 100) {
    return d3.format(",")(Math.round(thresholdsValues[i])).replace(/,/g, ".");
  }
  if ((i === 0) & sin_info) {
    return "s/n";
  }
  return roundedValues
    ? Math.round(thresholdsValues[i]) 
    : thresholdsValues[i];
}

export function legend({
  color,
  title,
  subtitle,
  subtitleFontSize,
  subtitleFontWeight,
  subTitlemarginTop,
  subTitlemarginBottom,
  titleFontSize = "14px",
  titleFontWeight = "400",
  tickFontSize = "12px",
  tickSize = 6,
  tickWidth = 1,
  tickFontWeight = "300",
  tickPos = 0,
  width = 320,
  height = 44 + tickSize,
  marginTop = 18,
  marginRight = 0,
  marginBottom = 16 + tickSize,
  marginLeft = 0,
  roundedValues = true,
  tickFormat,
  tickValues,
  tickThresholds,
  sin_info = false,
} = {}) {
  const svg = d3
    .create("svg")
    .attr("width", width)
    .attr("height", height)
    .style("overflow", "visible")
    .style("display", "block");

  svg.append("defs").append("style").attr("type", "text/css");

  let x;

  // Discrete
  if (color.invertExtent) {
    const thresholds = color.thresholds(); // scaleQuantize

    x = d3
      .scaleLinear()
      .domain([-1, color.range().length - 1]) //tamaño colores
      .rangeRound([marginLeft, width - marginRight]);

    let colorRange = color.range();

    if (sin_info) {
      for (let i = colorRange.length; i > 0; i--) {
        colorRange[i] = colorRange[i - 1];
      }
      colorRange[0] = "#EDEDED";
    }

    svg
      .append("g")
      .selectAll("rect")
      .data(colorRange)
      .join("rect")
      .attr("x", (d, i) => x(i - 1))
      .attr("y", marginTop)
      .attr("width", (d, i) => x(i) - x(i - 1))
      .attr("height", height - marginTop - marginBottom)
      .attr("fill", (d) => d);

    if (tickThresholds === undefined) {
      let thresholdsValues = thresholds.slice();
      thresholdsValues.unshift(color.domain()[0]);
      thresholdsValues.push(color.domain()[1]);

      tickFormat = (i) =>
        thresholdFormat(thresholdsValues, i, sin_info, roundedValues);
      tickValues = d3.range(thresholds.length + 2);
    } else {
      let thresholdsValues = tickThresholds.slice();
      tickFormat = (i) =>
        thresholdFormat(thresholdsValues, i, sin_info, roundedValues) + "%";
      tickValues = d3.range(tickThresholds.length);
    }
  }


  let titlePosition =
    color.range().length % 2
      ? Math.round(color.range().length / 2) * x(0) + x(0) / 2
      : (color.range().length / 2 + 1) * x(0);

  let subTitlePosition =
    color.range().length % 2
      ? Math.round(color.range().length / 2) * x(0) + x(0) / 2
      : (color.range().length / 2 + 1) * x(0);

  svg
    .append("g")
    .attr(
      "transform",
      `translate(-${x(0)},${height - marginBottom - tickSize / 2})`
    )
    .call(
      d3
        .axisBottom(x)
        .tickFormat(typeof tickFormat === "function" ? tickFormat : undefined)
        .tickSize(tickSize)
        .tickValues(tickValues)
    )
    .style("font-size", tickFontSize)
    .style("font-weight", tickFontWeight)
    .call((g) =>
      g
        .selectAll(".tick line")
        .attr("y1", marginTop + marginBottom - height + tickPos)
    )
    .call((g) => g.selectAll(".tick line").attr("stroke-width", tickWidth))
    .call((g) => g.select(".domain").remove())
    .call((g) =>
      g
        .append("text")
        .attr("x", titlePosition + 10)
        .attr("y", marginTop + marginBottom - height - 6)
        .attr("fill", "currentColor")
        .attr("text-anchor", "middle")
        .style("font-weight", titleFontWeight)
        .style("font-size", titleFontSize)
        .text(title)
    )

    .call((g) =>
      g
        .append("text")
        .attr("x", subTitlePosition + 20)
        .attr("y", subTitlemarginTop + subTitlemarginBottom - height + 30)
        .attr("fill", "currentColor")
        .attr("text-anchor", "middle")
        .style("font-weight", subtitleFontWeight)
        .style("font-size", subtitleFontSize)
        .text(subtitle)   
    );
  return svg.node();
}
